import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

/** @public */
export const EntityCatalogGraphCardCustom = () => {
  const { entity } = useEntity();
  const qrCode = entity?.metadata?.qrCode as string;
  const height = qrCode ? 200 : 400;

  return <EntityCatalogGraphCard height={height} />;
};
